<mat-toolbar class="main-toolbar">
  <div class="container">
    <div class="container-logo">
      <a [routerLink]="'dashboard'"
        ><img src="assets/logo.svg" alt="PLL LOT" width="100"
      /></a>
    </div>
    <div class="container-actions">
      <mat-icon>settings</mat-icon>
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
      >
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <mat-icon>account_circle</mat-icon>
          <span
            >Logged in as: <span>{{ accountName }}</span></span
          >
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
